export default import.meta.ROLLDOWN_FILE_URL_uaQjDjz0BgptWoPcKO2NJg